import palette from '../../palette';

export default {
  root: {
    "& .MuiButton-root": {
      padding: '5px 20px',
      "&:hover": {
        backgroundColor: palette.grayDisable
      }
    },
    "& .MuiButton-textPrimary": {
      color: palette.black
    }
  },
};